export default __webpack_public_path__ + "static/media/PPI-driveway-017.63bf1355.jpg";